import { useQuery } from 'data-fetching-client';
import { GET_LIST_DEFINITIONS } from 'flow-doctor-lib/queries/ListQueries';
const useILSList = ({
  portalId,
  listId
}, {
  skip
} = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_LIST_DEFINITIONS, {
    variables: {
      portalId,
      listIds: [listId]
    },
    skip
  });
  const dataToReturn = data ? data.listDefinitions.find(listDef => listDef.listId === listId) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useILSList;